import { T as fallback, a0 as spread_props, X as bind_props, a6 as sanitize_props } from "./index.js";
import { B as Button } from "./stores.js";
function DownloadButton($$payload, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  let primary = fallback($$props["primary"], true);
  let size = fallback($$props["size"], 0);
  let background = fallback($$props["background"], "dark");
  let enableStoreDownload = fallback($$props["enableStoreDownload"], false);
  Button($$payload, spread_props([
    {
      primary,
      background,
      size,
      class: "download-button",
      startIcon: "mdi:microsoft",
      label: "Download for Windows",
      secondaryLabel: "Free"
    },
    $$sanitized_props
  ]));
  $$payload.out += `<!----> `;
  if (enableStoreDownload) {
    $$payload.out += "<!--[-->";
    $$payload.out += `<a href="ms-windows-store://pdp/?productid=XP89FPP9MX5S91">`;
    Button($$payload, {
      primary: false,
      background,
      size,
      class: "download-button",
      startIcon: "mdi:shopping",
      label: "Get it from the Microsoft Store",
      secondaryLabel: "Free"
    });
    $$payload.out += `<!----></a>`;
  } else {
    $$payload.out += "<!--[!-->";
  }
  $$payload.out += `<!--]-->`;
  bind_props($$props, {
    primary,
    size,
    background,
    enableStoreDownload
  });
}
export {
  DownloadButton as D
};
